import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormBoxComponent } from '../../../ui/forms/form-box/form-box.component';
import { FormLabelComponent } from '../../../ui/forms/form-label/form-label.component';
import { FormSubmitButtonComponent } from '../../../ui/forms/form-submit-button/form-submit-button.component';
import { FormLinkComponent } from '../../../ui/forms/form-link/form-link.component';
import { HomeState } from '@mira-avant/mtlibs';
import { TextareaFieldComponent } from '../../../fields/standard/textarea-field/textarea-field.component';
import { ClientService } from '../../../../services/client.service';

@Component({
	selector: 'app-create-account-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		TextFieldComponent,
		FormBoxComponent,
		FormLabelComponent,
		FormSubmitButtonComponent,
		FormLinkComponent,
		TextareaFieldComponent,
	],
	templateUrl: './create-account-form.component.html',
	styleUrl: './create-account-form.component.scss',
})
export class CreateAccountFormComponent {
	@Output('onSubmit') public onSubmitEmitter = new EventEmitter<any>();
	@Output('onSwitchState') public onSwitchStateEmitter = new EventEmitter<HomeState>();
	@Input('loading') public loading = false;

	bootingUp = signal(true);
	isEduskillsAllowed = signal(false);

	form: FormGroup;

	constructor(
		private fb: FormBuilder,
		private clientService: ClientService
	) {
		this.form = this.fb.group({
			sectionCodes: ['', [Validators.required]],
			firstName: ['', []],
			lastName: ['', []],
			username: ['', [...TextFieldComponent.validators, Validators.required]],
		});

		this.loadEduskillsStatus();
	}

	private async loadEduskillsStatus() {
		const isAllowed = await this.clientService.isEduskillsAllowed$();
		this.isEduskillsAllowed.set(isAllowed);

		if (isAllowed) {
			this.form.removeControl('sectionCodes');
		}

		this.bootingUp.set(false);
	}

	onSubmit(): void {
		if (this.form.valid) {
			this.onSubmitEmitter.emit(this.form.value);
		}
	}

	clear(): void {
		this.form.reset();
	}

	public onBack() {
		this.onSwitchStateEmitter.emit(HomeState.LOGIN);
	}
}
